// extracted by mini-css-extract-plugin
export default {"paymentSection":"Z0-z","disabled":"_0-z"};